import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex-col view-wrapper"
}
const _hoisted_2 = {
  id: "editExisting",
  class: "flex-col page-header"
}
const _hoisted_3 = { class: "existing-waivers flex-col" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 2,
  class: "modal flex-center"
}
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = {
  key: 1,
  class: "confirm-form"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_display = _resolveComponent("loader-display")!
  const _component_date_input = _resolveComponent("date-input")!
  const _component_OnClickOutside = _resolveComponent("OnClickOutside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_loader_display, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.showBackBtn)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "back-btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
                }))
              : _createCommentVNode("", true),
            _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "page-title bold" }, "Completed Adult Waivers", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("span", null, " This section only applies if your order contains more than one experience, and only gives you the ability to apply your waiver to a new experience. If you need to edit personal information in your waiver, you’ll need to complete a new waiver. To maintain privacy, minors with completed waivers are only shown after parent or guardian’s identity is validated. ", -1))
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consents, (consent, i) => {
              return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(["si-input si-alt", _ctx.canEdit ? 'edit-btn' : 'no-edit']),
                key: consent.consentKey,
                onClick: ($event: any) => (_ctx.confirmEdit(i)),
                notranslate: ""
              }, _toDisplayString(consent.firstName) + " " + _toDisplayString(consent.lastName), 11, _hoisted_4))
            }), 128))
          ])
        ])),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_OnClickOutside, {
            onTrigger: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeModal()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.isConfirming)
                  ? (_openBlock(), _createBlock(_component_loader_display, { key: 0 }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_date_input, {
                        label: `Verify ${_ctx.consents[_ctx.selectedConsent].firstName ?? ''}'s birthday`,
                        day: _ctx.confirmationDate.day,
                        month: _ctx.confirmationDate.month,
                        year: _ctx.confirmationDate.year,
                        errorMsg: 'Incorrect birthday',
                        onOnDateEntered: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmationDate = $event)),
                        showError: _ctx.invalidDate,
                        id: 'confirmationDate',
                        altStyle: true
                      }, null, 8, ["label", "day", "month", "year", "showError"]),
                      _createElementVNode("button", {
                        class: "form-submit-btn",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validateBirthday()))
                      }, "OK")
                    ]))
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}